import type { Logger } from "@expert/logging";

import { useVerifiedCustomerStore } from "@expert/sales-tools";
import { isGuideSupported, sendMetadata, useGuideStore } from "@expert/solve-tools";
import { useEffect } from "react";

export const useGuideDeviceInfo = ({ logger, sessionId }: { logger: Logger; sessionId: string }) => {
    const { sessionMetadata, setSessionMetadata } = useGuideStore();
    const { deviceReplacement } = useVerifiedCustomerStore((state) => state.getVerifiedCustomer(sessionId));

    const isDeviceActivationGuideSupported = isGuideSupported("Device Activation");

    useEffect(() => {
        if (!isDeviceActivationGuideSupported || !deviceReplacement) return;

        const { eSim, imei, iccid } = deviceReplacement;
        const updatedSessionMetadata = { eSim, imei, iccid };

        if (
            sessionMetadata.imei === updatedSessionMetadata.imei &&
            sessionMetadata.iccid === updatedSessionMetadata.iccid
        )
            return;

        logger.info("Solve Guide | Setting device replacement info in session metadata");
        setSessionMetadata(updatedSessionMetadata);

        // refresh the metadata in the logic builder backend by updating moreTicketInfo
        sendMetadata({ metadata: updatedSessionMetadata });
        // oxlint-disable-next-line exhaustive-deps
    }, [deviceReplacement, isDeviceActivationGuideSupported, sessionMetadata, setSessionMetadata]);
};
